import React from 'react';
import { Icon } from "semantic-ui-react";


function TheIcon (props) {
  return <Icon name="content" {...props} />;
}

export const meta = {
  id: 'CMSMenusDetails',
  title: 'CMSMenusDetails',
  category: 'CMS',
  unique: false,
  icon: TheIcon,
  version: '1.0.0',
  description: `Manages the menus for the CMS of a given tenant`,
  windowOptions: {
    // if not passed, will be centered
    // x: null,
    // y: null,
    width: 865,
    height: 680
  }
};
